var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldPet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.52 9.32c-3.89 0-7.31 3.15-7.64 7.03-.13 1.5.35 2.92 1.34 3.99C6.2 21.41 7.58 22 9.08 22h4.68c1.69 0 3.17-.66 4.18-1.85 1.01-1.19 1.41-2.77 1.14-4.43-.59-3.53-3.98-6.4-7.56-6.4z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.28 7.86a2.93 2.93 0 1 1 0-5.86 2.93 2.93 0 0 1 0 5.86zM16.94 9.028a2.44 2.44 0 1 1 0-4.88 2.44 2.44 0 0 1 0 4.88zM20.55 12.931a1.95 1.95 0 1 1 0-3.9 1.95 1.95 0 0 1 0 3.9zM3.94 10.982a2.44 2.44 0 1 1 0-4.88 2.44 2.44 0 0 1 0 4.88z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldPet);
export default __webpack_public_path__ + "static/media/vuesax-bold-pet.0117c6c02eb57650f3bbdac20d2a8b11.svg";
export { ForwardRef as ReactComponent };